export default "__VITE_ASSET__Cw6KPI10__"